import axios from "axios";

export const actions = {
    login({}, data) {
        return axios.post("/login", data);
    },
    register({}, { user }) {
        return axios.post("/register", user);
    },
    sendResetLink({}, user) {
        return axios.post("/password/email", user);
    },
    resetPasswordWithToken({}, user) {
        return axios.post("/password/reset", user);
    },
    resetPassword(context, user) {
        return actions.resetPasswordWithToken(context, user);
    },
};

export default actions;
